import { useTranslation } from 'react-i18next'

import { KpiTile } from '@/components/data/KpiTile'
import { splitMoney } from '@/lib/format'
import type { ClientMoneySummary, Money } from '@/types/domain'

/** The workbook's Total line as tiles. Figures are SERVED, never summed here
 *  (AD-9): the page hands over the server's `totals` and renders it. `opening`
 *  is the statement's extra tile; the overview has none. */
export function ClientMoneyTiles({
  money,
  opening,
}: {
  money: ClientMoneySummary
  opening?: Money
}) {
  const { t } = useTranslation()
  const tile = (label: string, value: Money) => {
    const { amount, currency } = splitMoney(value.amount, value.currency)
    return <KpiTile label={label} value={amount} unit={currency} />
  }
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 xl:grid-cols-5">
      {opening ? tile(t('clients.tiles.opening'), opening) : null}
      {tile(t('clients.tiles.billed'), money.billed)}
      {tile(t('clients.tiles.received'), money.received)}
      {tile(opening ? t('clients.tiles.balanceToday') : t('clients.tiles.balance'), money.balance)}
      {tile(t('clients.tiles.cost'), money.cost)}
    </div>
  )
}
